import { render, staticRenderFns } from "./MainProducts.vue?vue&type=template&id=038979af&scoped=true"
import script from "./MainProducts.vue?vue&type=script&lang=js"
export * from "./MainProducts.vue?vue&type=script&lang=js"
import style0 from "./MainProducts.vue?vue&type=style&index=0&id=038979af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038979af",
  null
  
)

export default component.exports